import type Complaint from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/types/Complaint';

/**
 * Updates the app store's `formData.complaint` property with data from the component.
 */
export default async (context:any) => {
    const moduleId = context.getters.moduleId;

    let violations = context.rootState[`${ moduleId }_violations`].value;
    if (violations) {
        violations = violations.map((violation:string) => {
            let other = '';
            if (violation === 'OTH') {
                other = context.rootGetters['appState/selectedOption']('violationOptions', violation);
            }
            return {
                type: violation,
                other,
            };
        });
    }

    const workEnd = context.rootState[`${ moduleId }_work-end`].value;
    const endReason = context.rootState[`${ moduleId }_end-reason`].value;

    const data:Complaint = {
        preliminary      : context.rootState[`${ moduleId }_preliminary`].value,
        violations,
        description      : context.rootState[`${ moduleId }_description`].value,
        startDate        : context.rootState[`${ moduleId }_complaint-start`].value,
        endDate          : context.rootState[`${ moduleId }_complaint-end`].value,
        complainant      : context.rootState[`${ moduleId }_complainant`].value,
        quantity         : context.rootState[`${ moduleId }_quantity`].value,
        forSelf          : context.rootGetters['appState/forSelf'],
        forMultipleMinors: context.rootGetters['appState/forMultipleMinors'],
        relationship     : context.rootState[`${ moduleId }_relationship`].value,
        firstName        : context.rootState[`${ moduleId }_first-name`].value,
        lastName         : context.rootState[`${ moduleId }_last-name`].value,
        birthDate        : context.rootState[`${ moduleId }_birth-date`].value,
        workStart        : context.rootState[`${ moduleId }_work-start`].value,
        workEnd,
        isTerminated     : !!workEnd.length || !!endReason.length,
        endReason,
        otherReason      : context.rootState[`${ moduleId }_other-reason`].value,
    };

    await context.dispatch('updateData', {
        key  : 'complaint',
        value: data,
    }, { root: true });
};